export const LeadPoolConfigurationsPermissions = {
  ViewLeadPoolConfiguration: {
    permissionsId: "bd6a9046-5c79-4aad-d917-08dd66bd7136",
    permissionsName: "View Lead Pool Configuration",
    description: null,
    componentsId: null,
    components: null,
  },
};
